<template>
  <div class="bottom">
   
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {},
};
</script>

<style scoped>
.bottom {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2.7vh;
  background: url("../assets/img/bottom-line.png") no-repeat;
  z-index: 10;
}


</style>
